import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  ASKFORPRINT,
  BACKDATEALLOWED,
  CUSTOMER_DISABLE_IN_BILL,
  CUSTLOYALITYPOINT,
  DELETEREASON,
  DELETEBILLCONFIG,
  EPAYMENTSMS,
  GENERATEBILL,
  GSTFEATURE,
  HOMEDELVDETAILS,
  HOTELSALESCONFIG,
  ITEMWISEOFFER,
  KOTPRINTITEMWISE,
  KOTPRINTNOWISE,
  PARTILBILLAUDIT,
  PRICE_CHANGE_IN_BILL,
  WHATSAPPBILLCONFIG,
  printDebugLog,
} from "../../../constants/constant";
import { updateBillPaymentDetails } from "../../../store/billDetailsSlice";
import { fetchAllConfigs } from "../../../store/restoBillConfigSlice";
import { getDefaultRestoGstAllowed } from "../../../utilities/commonUtilities";

export const RESTO_BILL_CONFIG_NAMES = [
  GSTFEATURE,
  HOTELSALESCONFIG,
  BACKDATEALLOWED,
  ITEMWISEOFFER,
  DELETEBILLCONFIG,
  CUSTLOYALITYPOINT,
  PRICE_CHANGE_IN_BILL,
  GENERATEBILL,
  HOMEDELVDETAILS,
  KOTPRINTITEMWISE,
  KOTPRINTNOWISE,
  DELETEREASON,
  ASKFORPRINT,
  EPAYMENTSMS,
  PARTILBILLAUDIT,
  CUSTOMER_DISABLE_IN_BILL,
  WHATSAPPBILLCONFIG,
];

export const getOpenedRestoBillNo = (location = {}) => {
  const queryBillNo = new URLSearchParams(location.search || "").get("bNo");
  return location.state?.sBillNo
    || queryBillNo
    || location.state?.tableProps?.billNo
    || "";
};

/**
 * Refreshes bill configuration for every bill entry and applies the GST default
 * from that request only. This prevents a previous visit's Redux value from
 * winning the race against the current get-multiple-configs response.
 */
export const useRestoBillConfiguration = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const shop = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash,
  );
  const backendBaseUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL?.BACKEND_BASE_URL,
  );

  useEffect(() => {
    const request = dispatch(fetchAllConfigs(RESTO_BILL_CONFIG_NAMES));

    request.unwrap().then((configs) => {
      if (getOpenedRestoBillNo(location)) return;

      const defaultGstDisabled = Object.prototype.hasOwnProperty.call(
        configs,
        GSTFEATURE,
      ) ? configs[GSTFEATURE] : false;

      dispatch(updateBillPaymentDetails({
        isGstAllowed: getDefaultRestoGstAllowed(defaultGstDisabled),
      }));
    }).catch((error) => {
      if (error?.name !== "AbortError") {
        printDebugLog("Unable to refresh restaurant bill configuration", error);
        if (!getOpenedRestoBillNo(location)) {
          dispatch(updateBillPaymentDetails({ isGstAllowed: true }));
        }
      }
    });

    return () => request.abort();
  }, [backendBaseUrl, dispatch, location, shop?.cartType, shop?.id]);
};
